export default "__VITE_ASSET__BsRWQmRK__"